import styled from 'styled-components'

const Title = styled.h1`
margin: 30px auto;
height: 60px;
width: max-content;
padding: 10px;
border-radius: 10px;
text-align: center;
font-family: "Shadows Into Light", cursive;
line-height: 36px;
font-size: 50px;
`
export default Title